import { render } from "./ReferralLead.vue?vue&type=template&id=55e6030d&scoped=true"
import script from "./ReferralLead.vue?vue&type=script&lang=js"
export * from "./ReferralLead.vue?vue&type=script&lang=js"

import "./ReferralLead.vue?vue&type=style&index=0&id=55e6030d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e6030d"]])

export default __exports__